// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__d5gIL","boxTitle":"Qualiphy_boxTitle__1BdJr","box":"Qualiphy_box__1n3Ff","toggleWrap":"Qualiphy_toggleWrap__1fgm7"};